import React from 'react'

const Jva_io = () => {
    return (
        <div className='container'>
            <h1>How to get User Input In Java</h1>
            <p><strong>Introduction</strong></p>
            <p>Taking user input in Java is the first step towards creating successful software in Java. The Java program collects input from the user through various input sources such as a mouse, keyboard, network request, CLI arguments, etc. Java also has various I/O packages that can be imported into the program to perform input-output operations. These packages support input of primitive types like double, integer, strings, etc.</p>
            <p><span style={{fontWeight: '400'}}>This article will focus on methods like Scanner, BufferedReader, and InputStreamReader to take user </span><b>input in Java</b><span style={{fontWeight: '400'}}>.</span></p>
            <h2><b>How to Take Input in Java using the Scanner Class?</b></h2>
            <p><span style={{fontWeight: '400'}}>The Scanner class is one of the methods in the “java.util” package that parses and handles all the primitive type inputs. The Scanner class asks the user to enter the input, and then it prints the same on the screen or console. You can import the Scanner class from the “java.util” package in the program and create an object to use its methods.</span></p>
            <p><span style={{fontWeight: '400'}}>For example,</span></p>
            <p><b>Scanner test = new Scanner(System.in);</b></p>
            <p><span style={{fontWeight: '400'}}>In the above statement, the test is the name of an object, and System.in is the input stream. The Scanner instance created will scan the user </span><b>input in Java</b><span style={{fontWeight: '400'}}>.</span></p>
            <p><span style={{fontWeight: '400'}}>Note: It is not necessary to write System.in as the input string in your program. You can replace it with a file and a file to read, string as the input stream.</span></p>
            <p><span style={{fontWeight: '400'}}>For example,</span></p>
            <p><b>Scanner test = new Scanner(new FileInputStream(“testFile.txt”), “UTF-8”);</b></p>
            <p><span style={{fontWeight: '400'}}>Make sure that you write code &#123;test.close()&#125; to close the scanner when you are done editing it.</span></p>
            <p><b>Scanner Methods for Reading Inputs from User</b></p>
            <p><span style={{fontWeight: '400'}}>The following table lists the methods that the scanner uses to read the </span><b>input in Java</b><span style={{fontWeight: '400'}}> entered by the user.</span></p>
            <table>
<tbody>
<tr>
<td><b>Method</b></td>
<td><b>Return Type</b></td>
<td><b>Description</b></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>Next()</span></td>
<td><span style={{fontWeight: '400'}}>String</span></td>
<td><span style={{fontWeight: '400'}}>Returns the next token from the Scanner</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>nextByte()</span></td>
<td><span style={{fontWeight: '400'}}>Byte</span></td>
<td><span style={{fontWeight: '400'}}>Reads the next input as a byte.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>nextFloat()</span></td>
<td><span style={{fontWeight: '400'}}>Float</span></td>
<td><span style={{fontWeight: '400'}}>Reads the next input as a float.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>nextInt()</span></td>
<td><span style={{fontWeight: '400'}}>Integer</span></td>
<td><span style={{fontWeight: '400'}}>Reads the next input as an integer.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>nextShort()</span></td>
<td><span style={{fontWeight: '400'}}>Short</span></td>
<td><span style={{fontWeight: '400'}}>Read the next input as a short.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>nextLong()</span></td>
<td><span style={{fontWeight: '400'}}>Long</span></td>
<td><span style={{fontWeight: '400'}}>Read the next input as a long.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>nextBoolean()</span></td>
<td><span style={{fontWeight: '400'}}>Boolean</span></td>
<td><span style={{fontWeight: '400'}}>Reads the next input as a Boolean and returns the value.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>nextLine()</span></td>
<td><span style={{fontWeight: '400'}}>String</span></td>
<td><span style={{fontWeight: '400'}}>Advances the scanner one line and returns the input skipped.</span></td>
</tr>
</tbody>
</table>
<p><span style={{fontWeight: '400'}}>&nbsp;</span><b>Example</b></p>
<p><span style={{fontWeight: '400'}}>The following Java program uses the Scanner class to take user </span><b>input in Java </b><span style={{fontWeight: '400'}}>(string, integer, and a float).</span></p>
<div className='containers'><span style={{fontWeight: '400'}}>import java.util.Scanner;</span>
    <p></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;class TakeUserInput</span></p>
    <p><span style={{fontWeight: '400'}}>&#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;public static void main(String args[])</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;</span> <span style={{fontWeight: '400'}}>int a;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;</span> <span style={{fontWeight: '400'}}>float b;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;</span> <span style={{fontWeight: '400'}}>String c;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;</span> <span style={{fontWeight: '400'}}>Scanner test = new
            Scanner(System.in);</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;</span> <span style={{fontWeight: '400'}}>//Take user input as
            String</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(“Type a string: “);</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;</span> <span style={{fontWeight: '400'}}>c = in.nextLine();</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(“User Input String is:
            “+c);</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;</span> <span style={{fontWeight: '400'}}>//Take user input as
            Integer</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(“Type an integer: “);</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;</span> <span style={{fontWeight: '400'}}>a = in.nextInt();</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(“User Input Integer is:
            “+a);</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;</span> <span style={{fontWeight: '400'}}>//Take user input as
            float</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(“Type a float number: “);</span>
    </p>
    <p><span style={{fontWeight: '400'}}>&nbsp;</span> <span style={{fontWeight: '400'}}>b = in.nextFloat();</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(“User Input Float number is:
            “+b);</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&#125;&#125;</span></p>
</div>
<p><b>Output</b></p>
<div className='output'>
<td><span style={{fontWeight: '400'}}>Type a string:</span><p></p>
<p><span style={{fontWeight: '400'}}>Andrew</span></p>
<p><span style={{fontWeight: '400'}}>User Input String is: Andrew</span></p>
<p><span style={{fontWeight: '400'}}>Type an integer:</span></p>
<p><span style={{fontWeight: '400'}}>03</span></p>
<p><span style={{fontWeight: '400'}}>User Input Integer is: 03</span></p>
<p><span style={{fontWeight: '400'}}>Type a float number:</span></p>
<p><span style={{fontWeight: '400'}}>61.46</span></p>
<p><span style={{fontWeight: '400'}}>User Input Float number is: 61.46</span></p></td>
</div>
<h2><b>BufferedReader and InputStreamReader Methods</b></h2>
<p><span style={{fontWeight: '400'}}>BufferedReader is another class in Java that scans the stream of characters from a character-based input stream. InputStreamReader is a function in Java that converts the input stream into a sequence of characters for BufferedReader to scan. The BufferedReader class accepts the InputStream as a parameter.</span></p>
<p><span style={{fontWeight: '400'}}>The BufferedReader class uses read() and readLine() methods to read characters and the next line and returns them.</span></p>
<p><span style={{fontWeight: '400'}}>You must import the java.io.BufferedReader package to create a BufferedReader class.&nbsp;&nbsp;</span></p>
<p><span style={{fontWeight: '400'}}>// Creates a FileReader</span></p>
<p><b>FileReader test = new FileReader(String file);</b></p>
<p><span style={{fontWeight: '400'}}>// Creates a BufferedReader</span></p>
<p><b>BufferedReader a = new BufferedReader(test);</b></p>
<h2><b>BufferedReader Methods for Reading Inputs from User</b></h2>
<p><span style={{fontWeight: '400'}}>The following table lists the methods that the buffered reader uses to read the </span><b>input in Java</b><span style={{fontWeight: '400'}}> entered by the user.</span></p>
<table>
<tbody>
<tr>
<td><b>Method</b></td>
<td><b>Description</b></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>ready()</span></td>
<td><span style={{fontWeight: '400'}}>Verifies if the file reader is in a read state.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>mark()</span></td>
<td><span style={{fontWeight: '400'}}>Marks the position in the buffered reader up to which the data has been read.</span></td>
</tr>
<tr>
<td><span style={{fontWeight: '400'}}>reset()</span></td>
<td><span style={{fontWeight: '400'}}>Returns the control to the point where the mark was set.</span></td>
</tr>
</tbody>
</table>
<p><b>Example</b></p>
<p><span style={{fontWeight: '400'}}>The following Java program uses a BufferedReader class alongside an InputStreamReader class to take the user </span><b>input in Java</b><span style={{fontWeight: '400'}}>.</span></p>
<div className='containers'>
    <td><span style={{fontWeight: '400'}}>import java.io.BufferedReader;</span><p></p>
    <p><span style={{fontWeight: '400'}}>import java.io.FileReader;</span></p>
    <p><span style={{fontWeight: '400'}}>import java.io.IOException;</span></p>
    <p><span style={{fontWeight: '400'}}>public class test &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;public static void main(String[] args) &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;BufferedReader buffer = null;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;try &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;String scanFirstLine;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;buffer = new BufferedReader(new FileReader(“D:\\user_input.txt”));</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;while ((scanFirstLine = buffer.readLine()) != null) &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(scanFirstLine);</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&#125;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&#125; catch (IOException a) &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;a.printStackTrace();</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&#125; finally &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;try &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;if (buffer != null)</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;buffer.close();</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&#125; catch (IOException b) &#123;</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&nbsp;b.printStackTrace();</span></p>
    <p><span style={{fontWeight: '400'}}>&nbsp;&nbsp;&nbsp;&#125;&nbsp; &#125; &#125; &#125;</span></p></td>
    </div>
    <p><b>Output</b></p>
    <div className='output'>
<td><span style={{fontWeight: '400'}}>The following data is found in the file:</span><p></p>
<p><span style={{fontWeight: '400'}}>This is a sample statement that BufferedReader reads from the file.</span></p></td>
</div>
<p><span style={{fontWeight: '400'}}>In the above example, we created a buffered reader named buffer. The buffered reader is linked with the “user_input.txt” file.</span></p>
<p><span style={{fontWeight: '400'}}>Then, we used the readLine() method to scan the characters from the buffer of the buffered reader.</span></p>
        </div>
    )
}

export default Jva_io
